import type { CSSProperties } from 'react';

import { isEventModePath } from '@/components/layout/nav/primaryRoutes';

export const SHELL_HEADER_HEIGHT = 56;
const SAFE_TOP = 'env(safe-area-inset-top, 0px)';

export interface ShellChrome {
  // The shell's own top bar is left out; the page header owns the top edge instead.
  headerHidden: boolean;
  // Mobile tab bar for the standard app tabs; event mode brings its own.
  standardTabBar: boolean;
  // Height of the fixed impersonation banner (status-bar inset included), or 0px.
  bannerOffset: string;
  rootVars: CSSProperties;
}

// On phones an event workspace replaces the shell's top bar and tab bar with its own. With the
// shell bar gone the event header is the top-most surface, so it pads itself under the status
// bar (`--page-header-inset`) unless the impersonation banner already covers that inset.
export function shellChrome({ pathname, mobile, impersonationBannerHeight }: {
  pathname: string; mobile: boolean; impersonationBannerHeight: number | null;
}): ShellChrome {
  const eventMode = isEventModePath(pathname);
  const headerHidden = eventMode && mobile;
  const bannerOffset = impersonationBannerHeight == null ? '0px' : `calc(${impersonationBannerHeight}px + ${SAFE_TOP})`;
  const vars: Record<string, string> = headerHidden
    ? {
      '--app-shell-header-offset': bannerOffset,
      '--page-header-top': bannerOffset,
      '--page-header-inset': impersonationBannerHeight == null ? SAFE_TOP : '0px',
    }
    : { '--app-shell-header-offset': `calc(${SHELL_HEADER_HEIGHT}px + ${SAFE_TOP} + ${bannerOffset})` };
  const rootVars = vars as CSSProperties;
  return { headerHidden, standardTabBar: !eventMode, bannerOffset, rootVars };
}
